import axios from 'axios';

export default {
  state: {
    user: null,
    interviews: null
  },
  mutations: {
    editProfile(s, params) {
      s.user ? s.user.profile[params.key] = params.val : '';
    },
    setUser(state, user) {
      state.user = user;
    },
    setProfileEvents(state, events) {
      state.user.events = events;
    },
    setProfilePlaces(state, places) {
      state.user.places = places;
    },
    setInterviews(state, interviews) {
      state.interviews = interviews;
    }
  },
  actions: {
    async changeSetting({commit}, params) {
        let result;
        commit
        await axios
          .post(`/api/settings/change`, params)
          .then((response) => {
            result = response.data;
          })
        return result;
      },
    async getSettings() {
        let result;
        await axios
          .post(`/api/settings`)
          .then((response) => {
            result = response.data;
          })
        return result;
      },
    async getUser({ commit }, params) {
        let result;
        await axios
          .post(`/api/profile`, params)
          .then((response) => {
            commit('setUser', response.data);
            result = response.data;
          })
        return result;
      },
      async editProfile({ commit }, params) {
        commit('editProfile', params);
      },
      async changeProfileSports({ commit }, params) {
          let result;
          commit
          await axios
            .post(`/api/profile/edit/sports`, params)
            .then((response) => {
              result = response.data;
            })
          return result;
        },
      async deletePhotoProfile({ commit }, params) {
          let result;
          commit
          await axios
            .post(`/api/profile/deletePhoto`, params)
            .then((response) => {
              result = response.data;
            })
          return result;
        },
        async addPhotoProfile ({ commit }, params) {
          let result = null;
          await axios
            .post(`/api/profile/addPhoto`, params)
            .then(response => {
              result = response.data
              commit
            })
          return result;
        },
        async fetchProfileEvents ({ commit }, params) {
          let result = null;
          await axios
            .post(`/api/profile/events`, params)
            .then(response => {
              result = response.data
              commit('setProfileEvents', response.data)
            })
          return result;
        },
        async fetchProfilePlaces ({ commit }, params) {
          let result = null;
          await axios
            .post(`/api/profile/places`, params)
            .then(response => {
              result = response.data
              commit('setProfilePlaces', response.data)
            })
          return result;
        },
        async setInterview({ commit }, params) {
          let result = null;
          commit;
          await axios
            .post('/api/account/interviews/add', params)
            .then(async response => {
              result = response.data[0]
            })
          return result;
        },
        async getInterviews({ commit }) {
          let result = null;
          await axios
            .post('/api/account/interviews/all')
            .then(async response => {
              console.log(response,'response');
              result = response.data
              commit('setInterviews', result)
            })
          return result;
        }
  },
  getters: {
    getUser: (s) => s.user,
    getInterviews: (s) => s.interviews
  },
};
